import React, { FC } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { Block, Spacing } from 'ia-react-core';
import { StyledDiv, StyledHR, StyledP, StyledT3, StyledWarningIcon, StyledHtml } from '../PersonalInformationsConfirmationPageContent.styles';
import { ContractChangeMessage } from '../../../../interfaces/ContractChangeMessage';

export interface ConfirmationWarningSectionProps {
  allContracts: ContractChangeMessage[];
}

const ConfirmationWarningSection: FC<ConfirmationWarningSectionProps> = ({ allContracts }) => {
  const { t } = useTranslation('PersonalInformationsConfirmationPage');

  if (!allContracts || allContracts.length === 0) {
    return null;
  }

  const messages: JSX.Element[] = _(allContracts)
    .filter((x) => x.additionalInformations?.length > 1)
    .groupBy((x) => x.additionalInformations)
    .map((contracts, message) => (
      <div key={message}>
        {contracts.map((x, i) => <StyledP strong key={i} data-testid={`message-${x.adjustedNumber}`}>{`${x.description} ${x.adjustedNumber}`}</StyledP>)}
        <StyledHtml>{message}</StyledHtml>
      </div>
    ))
    .value();

  if (messages.length === 0) {
    return null;
  }

  for (let i = messages.length - 1; i > 0; i--) {
    messages.splice(i, 0, <StyledHR key={i} />);
  }

  return (
    <Block white data-testid="WarningSection">
      <StyledDiv>
        <StyledWarningIcon />
        <Spacing m-t={12}>
          <StyledT3>{t('warningLabel')}</StyledT3>
        </Spacing>
        {messages}
      </StyledDiv>
    </Block>
  );
};
export default ConfirmationWarningSection;
